import { create } from 'zustand'
import type { UserAccount } from '@/lib/types'
import type { User } from 'firebase/auth'

export type AuthStatus = 'loading' | 'unauthenticated' | 'pending' | 'suspended' | 'active'

interface AuthState {
  user: User | null
  account: UserAccount | null
  status: AuthStatus
  setUser: (user: User | null) => void
  setAccount: (account: AuthState['account']) => void
  setStatus: (status: AuthStatus) => void
  getToken: () => Promise<string | null>
  clearAuth: () => void
}

export const useAuthStore = create<AuthState>((set, get) => ({
  user: null,
  account: null,
  status: 'loading',
  setUser: (user) => set({ user }),
  setAccount: (account) => set({ account }),
  setStatus: (status) => set({ status }),
  getToken: async () => {
    const { user } = get()
    if (!user) return null
    return user.getIdToken()
  },
  clearAuth: () => set({ user: null, account: null, status: 'unauthenticated' }),
}))
